import root from 'window-or-global';

// return a clean pathname that removes the appContext and the locale
export function extractPath(pathname: string): string {
  const appContext = root.appContext ?? '';
  const localeExp = '(?:/[a-zA-Z]{2}(?:[_-][a-zA-Z]{2,4})?)';
  const regexpStr = `${appContext}${localeExp}?(?<slug>/.*)`;
  const match = pathname.match(new RegExp(regexpStr));
  const path = match && match.groups?.slug ? match.groups.slug : '/';
  return path;
}
